import {Cookies} from 'react-cookie';
import {
    APP_RESET,
    APP_FOCUS,
    APP_DOWNLOADED,
    APPS_DOWNLOADED,
    APPS_PENDING,
    APPS_FAILED,
    APP_FAILED,
    APP_POSTING,
    APP_EDITING,
    APP_DELETING,
    APPS_RESET,
    APP_DELETED,
    APP_PICTURE_UPLOADING,
    APP_PICTURE_FAILED,
    APP_PICTURE_UPLOADED,
    APP_PICTURE_DELETING,
    APP_PUSH_SUBSCRIBED,
    APP_PUSH_SUBSCRIBED_RESET
} from './types';
import APIService from '../../services/api'
import {handleError, genericInfoAction} from '../infos/actions'

const cookies = new Cookies();
export const fiveMinutesPushMessage = "The push notification has not been sent because an identical notification has been sent less than 5 minutes ago";

export const diplayedFiveMinutesPushMessage = 'Please wait 5 minutes before sending same push';
export const diplayedOkPushMessage = 'Push message sent';

// Action creators

export const resetAppAction = () => {
    return {type: APP_RESET};
};

export const resetAppsAction = () => {
    return {type: APPS_RESET};
};

export const appsPendingAction = () => {
    return {type: APPS_PENDING};
};

export const appPostingAction = () => {
    return {type: APP_POSTING};
};

export const appDeletedAction = (id) => {
    return {
        type: APP_DELETED,
        payload: id
    };
};

export const appDeletingAction = () => {
    return {type: APP_DELETING};
};

export const appEditingAction = () => {
    return {type: APP_EDITING};
};

export const appsDownloadedAction = (apps) => {
    return {
        type: APPS_DOWNLOADED,
        payload: apps
    };
};

export const appDownloadedAction = (app) => {
    return {
        type: APP_DOWNLOADED,
        payload: app
    };
};

export const appFocusAction = (app) => {
    return {
        type: APP_FOCUS,
        payload: app
    };
};

export const uploadPictureAction = (picture) => {
    return {
        type: APP_PICTURE_UPLOADING,
        payload: picture
    };
};

export const uploadPictureFailedAction = (error) => {
    return {
        type: APP_PICTURE_FAILED,
        payload: error.message
    };
};

export const uploadPictureSucceedAction = (type) => {
    return {
        type: APP_PICTURE_UPLOADED,
        payload: type
    };
};

export const deletePictureAction = () => {
    return {
        type: APP_PICTURE_DELETING
    };
};

export const subscribedToPushAction = (count) => {
    return {
        type: APP_PUSH_SUBSCRIBED,
        payload: count
    };
};

export const resetSubscribedToPushAction = () => {
    return {
        type: APP_PUSH_SUBSCRIBED_RESET
    };
};


// Handle

export function handlePushOk(message) {
    return (dispatch) => {
        let displayedMessage;

        if (message === fiveMinutesPushMessage) {
            displayedMessage = diplayedFiveMinutesPushMessage;
        } else {
            displayedMessage = diplayedOkPushMessage;
        }

        dispatch(genericInfoAction(displayedMessage));
    }
}

// Actions

export function resetApp() {
    return (dispatch) => {
        dispatch(resetAppAction());
    }
}

export function getApps() {
    return function (dispatch, getState) {
        dispatch(appsPendingAction());
        return APIService
            .getApplications(cookies.get('token'))
            .then(apps => {
                dispatch(appsDownloadedAction(apps));
            })
            .catch((error) => {
                dispatch(handleError(error, APPS_FAILED));
            });
    }
}

export function fetchApp(id) {
    return function (dispatch, getState) {
        let applications = getState().apps.content;
        let app = applications.find(function (app) {
            return app.id === id
        });

        if (app) {
            return dispatch(appFocusAction(app));
        } else {
            return dispatch(getApp(id));
        }
    }
}

export function getApp(id) {
    return function (dispatch) {
        dispatch(appsPendingAction());
        return APIService
            .getApp(id, cookies.get('token'))
            .then(app => {
                dispatch(appDownloadedAction(app));
            })
            .catch((error) => {
                dispatch(handleError(error, APP_FAILED));
            });
    }
}

export function postApp(app) {
    return function (dispatch) {
        dispatch(appPostingAction());
        return APIService
            .postApp(app, cookies.get('token'))
            .then(app => {
                dispatch(appDownloadedAction(app));
            })
            .catch((error) => {
                dispatch(handleError(error, APP_FAILED));
            });
    }
}

export function putApp(id, app) {
    return function (dispatch) {
        dispatch(appEditingAction());
        return APIService
            .putApp(id, app, cookies.get('token'))
            .then(app => {
                dispatch(appDownloadedAction(app));
            })
            .catch((error) => {
                dispatch(handleError(error, APP_FAILED));
            });
    }
}
export function postAppConfiguration(id, content, isFile = false) {
    return function (dispatch) {
        dispatch(appEditingAction());
        return APIService
            .postAppConfigurations(id, content, cookies.get('token'), isFile)
            .then(app => {
                dispatch(appDownloadedAction(app));
            })
            .catch((error) => {
                if (error.response && error.response.status === 400) {
                    dispatch(handleError(error.response.data.message));
                } else {
                    dispatch(handleError(error, APP_FAILED));
                }
            });
    }
}

export function deleteApp(id) {
    return function (dispatch) {
        dispatch(appDeletingAction());
        return APIService
            .deleteApp(id, cookies.get('token'))
            .then(() => {
                dispatch(appDeletedAction(id));
            })
            .catch((error) => {
                dispatch(handleError(error, APP_FAILED));
            });
    }
}

export function deleteAdmin(appId, adminId) {
    return function (dispatch) {
        dispatch(appEditingAction());
        return APIService
            .deleteAppAdmin(appId, adminId, cookies.get('token'))
            .then(app => {
                dispatch(appDownloadedAction(app));
            })
            .catch((error) => {
                dispatch(handleError(error, APP_FAILED));
            });
    }
}

export function addAdmin(appId, adminId) {
    return function (dispatch) {
        dispatch(appEditingAction());
        return APIService
            .addAppAdmin(appId, adminId, cookies.get('token'))
            .then(app => {
                dispatch(appDownloadedAction(app));
            })
            .catch((error) => {
                dispatch(handleError(error, APP_FAILED));
            });
    }
}

// push

export function getSubscribedPush(appId, push) {
    return function (dispatch) {
        return APIService
            .getSubscribedPush(appId, push, cookies.get('token'))
            .then(result => {
                if (result.message) {
                    try {
                        const subscribed = JSON.parse(result.message);
                        if (subscribed.result) {
                            dispatch(subscribedToPushAction(subscribed.result));
                        } else {
                            dispatch(resetSubscribedToPushAction());
                        }
                    } catch (error) {
                        dispatch(resetSubscribedToPushAction());
                        // dispatch(handleError(error, APP_PUSH_SUBSCRIBED_RESET));
                    }
                } else {
                    dispatch(resetSubscribedToPushAction());
                }
            })
            .catch((error) => {
                dispatch(handleError(error, APP_PUSH_SUBSCRIBED_RESET));
            });
    }
}

export function resetSubscribedPush() {
    return (dispatch) => {
        dispatch(resetSubscribedToPushAction());
    }
}

export function postPush(appId, push) {
    return function (dispatch) {
        dispatch(appPostingAction());
        return APIService
            .postPush(appId, push, cookies.get('token'))
            .then(result => {
                dispatch(handlePushOk(result.message));
            })
            .catch((error) => {
                dispatch(handleError(error, APP_FAILED));
            });
    }
}

export function postPushGroup(appId, pushGroup) {
    return function (dispatch) {
        dispatch(appPostingAction());
        return APIService
            .postPushGroup(appId, pushGroup, cookies.get('token'))
            .then(app => {
                dispatch(appDownloadedAction(app));
            })
            .catch((error) => {
                dispatch(handleError(error, APP_FAILED));
            });
    }
}

export function deletePushGroup(appId, pushGroup) {
    return function (dispatch) {
        dispatch(appPostingAction());
        return APIService
            .deletePushGroup(appId, pushGroup, cookies.get('token'))
            .then(app => {
                dispatch(appDownloadedAction(app));
            })
            .catch((error) => {
                dispatch(handleError(error, APP_FAILED));
            });
    }
}

export function postPushSound(appId, pushSound) {
    return function (dispatch) {
        dispatch(appPostingAction());
        return APIService
            .postPushSound(appId, pushSound, cookies.get('token'))
            .then(app => {
                dispatch(appDownloadedAction(app));
            })
            .catch((error) => {
                dispatch(handleError(error, APP_FAILED));
            });
    }
}

export function deletePushSound(appId, pushSound) {
    return function (dispatch) {
        dispatch(appPostingAction());
        return APIService
            .deletePushSound(appId, pushSound, cookies.get('token'))
            .then(app => {
                dispatch(appDownloadedAction(app));
            })
            .catch((error) => {
                dispatch(handleError(error, APP_FAILED));
            });
    }
}

// Picture

export function postAppPicture(appId, picture, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(uploadPictureAction(picture));
        return APIService
            .postAppPicture(appId, picture, cookies.get('token'), onUploadProgress)
            .then(app => {
                dispatch(appDownloadedAction(app));
                dispatch(uploadPictureSucceedAction(app));
            })
            .catch((error) => {
                dispatch(handleError(error, APP_FAILED));
                dispatch(uploadPictureFailedAction(error));
            });
    }
}

export function deleteAppPicture(appId) {
    return function (dispatch) {
        dispatch(deletePictureAction());
        return APIService
            .deleteAppPicture(appId, cookies.get('token'))
            .then((type) => {
                dispatch(appDownloadedAction(type));
            })
            .catch((error) => {
                dispatch(handleError(error, APP_FAILED));
            });
    }
}



// WEBPACK FOOTER //
// src/store/apps/actions.js